export default __webpack_public_path__ + "static/media/warning-fill.7c12ea4f.svg";